// Register the service worker and show a toast when a new version is ready.
// `vite-plugin-pwa`'s `registerType: 'autoUpdate'` already activates the new
// SW on next reload — this just nudges the user to reload now if they want.

import { toast } from 'sonner';
import { registerSW } from 'virtual:pwa-register';

export function startSwUpdateWatch(): void {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      toast('App updated', {
        description: 'Tap to reload and pick up the latest version.',
        duration: 12_000,
        action: {
          label: 'Reload',
          onClick: () => updateSW(true),
        },
      });
    },
    onOfflineReady() {
      // First install — silent
    },
  });
}
